import type { BuilderItem } from "../types/gangsheet";
import { EXPORT_DPI, SHEET_WIDTH_IN } from "./gangsheetMath";

export async function exportGangsheetPng(
  items: BuilderItem[],
  sheetLengthIn: number
) {
  const exportWidthPx = Math.round(SHEET_WIDTH_IN * EXPORT_DPI);
  const exportHeightPx = Math.round(sheetLengthIn * EXPORT_DPI);

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  if (!ctx) {
    throw new Error("Could not create export canvas.");
  }

  canvas.width = exportWidthPx;
  canvas.height = exportHeightPx;

  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = "high";

  for (const item of items) {
    const centerXPx = item.centerX * EXPORT_DPI;
    const centerYPx = item.centerY * EXPORT_DPI;
    const widthPx = item.widthIn * EXPORT_DPI;
    const heightPx = item.heightIn * EXPORT_DPI;

    ctx.save();
    ctx.translate(centerXPx, centerYPx);
    ctx.rotate((item.rotation * Math.PI) / 180);
    ctx.drawImage(item.imageEl, -widthPx / 2, -heightPx / 2, widthPx, heightPx);
    ctx.restore();
  }

  const blob = await new Promise<Blob | null>((resolve) =>
    canvas.toBlob(resolve, "image/png")
  );

  if (!blob) {
    throw new Error("Export failed.");
  }

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `gangsheet-22x${sheetLengthIn}-${Date.now()}.png`;
  a.click();
  URL.revokeObjectURL(url);
}